import '../assets/css/Custom.css';

const CustomButton = ({ buttonText, onClick, style, className, icon, iconClass, disabled, id, onKeyDown, type = "button" }) => {
  return (
    <div className="d-flex justify-content-center h-100">
      <button
        id={id}
        type={type}  
        className={className}
        style={style}
        onClick={onClick}
        disabled={disabled}  
        onKeyDown={onKeyDown}
      >
        <span className={iconClass}>{icon}</span>
        {buttonText}
      </button>
    </div>
  );
};
export default CustomButton;
